import { Button, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { MdOutlinePayment } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { errorToastOptions } from "../../../components/molecules/errorToastOptions";
import { captureRequestError } from "../../../helper/captureRequestError";
import { getFullPageUrl } from "../../../helper/getFullPageUrl";
import { Route, useNavigator } from "../../../routers/navigator";

export const PurchasePlanButton = ({ accountId }: { accountId: string }) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const toast = useToast(errorToastOptions);

  const navigate = useNavigator();

  const handleClick = async () => {
    setIsLoading(true);
    try {
      navigate({
        route: Route.Plans,
        accountId,
        state: {
          referringUrl: getFullPageUrl(location),
        },
      });
    } catch (error) {
      captureRequestError(error);
      toast({
        title: "Failed to open checkout",
        description: "An unexpected error occurred. Please try again later.",
      });
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="solid"
      colorScheme="primary"
      size="sm"
      isLoading={isLoading}
      onClick={handleClick}
      leftIcon={<MdOutlinePayment />}
    >
      Purchase plan
    </Button>
  );
};
